<script> 
export default {
    props: {
        status: {
            type: Number,
            default: 0
        }
    },
    render(h){
        /*
          h 类似于 createElement， 接受2个参数
          1 - 元素
          2 - 选项
        */
        var text = '';
        switch(parseInt(this.status)) {
            case 0:
            text = "离线"
            break;
            case 1:
            text = "在线"
            break;
            default: 
            text = "未知";
        };
        return h('label',{
            // 相当于 v-bind:class
            class: {
                'netoff': this.status === 0||this.status === '0',
                'neton': this.status === 1||this.status === '1',
                'unknow': this.status !== 1&&this.status !== '1'&& this.status !== 0&& this.status !== '0'
            },
            style: {
                color: this.status !== 1&&this.status !== '1'&& this.status !== 0&& this.status !== '0'?'red' : ''
            },
            domProps: {
                innerText: text
            }
        })
    }
}
</script>
<style scoped>
  .neton{
    background: #0ebad5;
    border:  1px solid #0ebad5;
    padding: 5px;
    border-radius: 4px;
    padding-left: 10px;
    padding-right: 10px;
    font-weight: bolid;
    color: white;
  }
  .netoff{
    background: gray;
    border:  1px solid gray;
    padding: 5px;
    border-radius: 4px;
    padding-left: 10px;
    padding-right: 10px;
    font-weight: bolid;
    color: white; 
  }
</style>